export default __webpack_public_path__ + "static/assets/35538f038471616a146551cdf17f86b0.png";